import { useLanguage } from '../../i18n/LanguageContext';
import { DashboardUpdate } from '../../types';

interface LatestUpdatesProps {
  updates: DashboardUpdate[];
}

function LatestUpdates({ updates }: LatestUpdatesProps) {
  const { t } = useLanguage();

  return (
    <div className="partner-updates-feed">
      <h3>{t('dashboard.updates.title')}</h3>

      {updates.length === 0 ? (
        <div className="partner-updates-empty">
          {t('dashboard.updates.empty')}
        </div>
      ) : (
        updates.map((update, index) => {
          const date = new Date(update.timestamp);
          const dateStr = date.toLocaleDateString();
          const timeStr = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
          return (
            <div key={index} className="partner-update-item">
              <span className="partner-update-time">{dateStr} {timeStr}</span>
              <span className="partner-update-message">{update.message}</span>
            </div>
          );
        })
      )}
    </div>
  );
}

export default LatestUpdates;
